import React from "react"
import { SimpleGrid } from "@chakra-ui/react"
import { Control, UseFormWatch } from "react-hook-form"
import WALLET_PASS_BUILDER_COPY from "./walletPassBuilderCopy"
import { WalletPassBuilderFormValues } from "./walletPassBuilderTypes"
import PassBuilderBrandingField from "./PassBuilderBrandingField"

type Props = {
  control: Control<WalletPassBuilderFormValues, object>
  watch: UseFormWatch<WalletPassBuilderFormValues>
  uploadingFields?: (keyof WalletPassBuilderFormValues)[]
}

const { branding } = WALLET_PASS_BUILDER_COPY

const PassBuilderBrandingSection = ({
  control,
  watch,
  uploadingFields = [],
}: Props) => (
  <SimpleGrid
    w="full"
    templateColumns="repeat(2, minmax(0, 1fr))"
    columnGap={14}
    rowGap={14}
  >
    <PassBuilderBrandingField
      title="Square Logo"
      name="squareLogo"
      control={control}
      platform="both"
      status="required"
      description={branding.squareLogo.description}
      dropLabel={branding.squareLogo.dropLabel}
      dropWidth={88}
      dropHeight={88}
      imageUrl={watch("squareLogoUrl")}
      isUploading={uploadingFields.includes("squareLogo")}
      accept="image/png"
      isRemovable={false}
    />
    <PassBuilderBrandingField
      title="Horizontal Logo"
      name="horizontalLogo"
      control={control}
      platform="apple"
      status="optional"
      description={branding.horizontalLogo.description}
      dropLabel={branding.horizontalLogo.dropLabel}
      dropWidth={165}
      dropHeight={52}
      imageUrl={watch("horizontalLogoUrl")}
      isUploading={uploadingFields.includes("horizontalLogo")}
      accept="image/png"
    />
    <PassBuilderBrandingField
      title="Apple Banner Image"
      name="appleBanner"
      control={control}
      platform="apple"
      status="optional"
      description={branding.appleBanner.description}
      dropLabel={branding.appleBanner.dropLabel}
      dropWidth={280}
      dropHeight={72}
      imageUrl={watch("appleBannerUrl")}
      isUploading={uploadingFields.includes("appleBanner")}
      imageFit="cover"
    />
    <PassBuilderBrandingField
      title="Google Hero Image"
      name="googleHero"
      control={control}
      platform="google"
      status="optional"
      description={branding.googleHero.description}
      dropLabel={branding.googleHero.dropLabel}
      dropWidth={280}
      dropHeight={90}
      imageUrl={watch("googleHeroUrl")}
      isUploading={uploadingFields.includes("googleHero")}
      imageFit="cover"
    />
  </SimpleGrid>
)

export default PassBuilderBrandingSection
